import toast from '../../components/toast';

const DEFAULT_MESSAGE = 'Algo salió mal. Inténtalo más tarde o contacta a un asesor';

const renderSomethingWentWrong = message => toast.danger(message ?? DEFAULT_MESSAGE);

export default renderSomethingWentWrong;
